import lockScroll from './lockscroll';

export default function modalMovie() {
  const modalBlocks = document.querySelectorAll('.js_movie');
  if (modalBlocks.length === 0) return;

  const { lock, unlock } = lockScroll();

  function showModal(content, trigger, movie, movieId) {
    content.setAttribute('aria-hidden', false);
    trigger.setAttribute('aria-expanded', true);
    movie.innerHTML = '';
    movie.innerHTML =
      '<iframe id="activeMovie" width="560" height="315" src="https://www.youtube.com/embed/' +
      movieId +
      '?autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
    lock();
  }
  function hideModal(content, trigger) {
    content.setAttribute('aria-hidden', true);
    trigger.setAttribute('aria-expanded', false);
    const iframeElement = document.getElementById('activeMovie');
    const parent = iframeElement.parentElement;
    parent.removeChild(iframeElement);
    unlock();
  }

  modalBlocks.forEach(modalBlock => {
    const trigger = modalBlock.querySelector('.js_movie_trigger');
    const content = modalBlock.querySelector('.js_movie_content');
    const closeButton = modalBlock.querySelector('.js_movie_close');
    const movie = modalBlock.querySelector('.js_movie_movie');
    const movieId = movie.id;

    trigger.addEventListener('click', () => {
      showModal(content, trigger, movie, movieId);
    });
    closeButton.addEventListener('click', () => {
      hideModal(content, trigger);
    });
    content.addEventListener('click', event => {
      if (!event.target.closest('.p-virtualDriveModal__movieWrap')) {
        hideModal(content, trigger);
      }
    });
  });
}
